import { type RouteRecordRaw } from "vue-router";
import { type MjfRouteMeta, RouteNames } from "@shared/types/localTypes/router";

export default {
  path: "/platform-sso-disabled",
  name: RouteNames.LandingPlatformSSODisabled,
  component: () => import("@/views/landing/PlatformSSODisabled.vue"),
  meta: { autoLogout: true } as MjfRouteMeta,
} as RouteRecordRaw;
